import { createSlice } from '@reduxjs/toolkit';
import { tokenStorage } from './tokenStorage';

export interface AuthState {
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  isAuthenticated: tokenStorage.get() !== null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signedIn(state) {
      state.isAuthenticated = true;
    },
    signedOut(state) {
      state.isAuthenticated = false;
    },
  },
});

export const { signedIn, signedOut } = authSlice.actions;
